import { cn } from "@/lib/utils";
import type { AppStatus } from "@/lib/apps-registry";
import { STATUS_LABEL } from "@/lib/apps-registry";

type Props = {
  status: AppStatus;
  className?: string;
  /** `compact` is sized for dense lists (see .status-pill.compact) rather than scaled down. */
  size?: "default" | "compact";
};

export function StatusBadge({ status, className, size = "default" }: Props) {
  return (
    <span className={cn("status-pill", status, size === "compact" && "compact", className)}>
      <span className="status-dot" />
      {STATUS_LABEL[status]}
    </span>
  );
}
